import React, {Component} from 'react';
import './QuestionAnswer.css';
import PropTypes from 'prop-types';

export default class QuestionAnswer extends Component {
    render() {
        return (
            <div className={"QuestionAnswer"} dangerouslySetInnerHTML={{__html: this.props.value}}/>
        );
    }
}

QuestionAnswer.propTypes = {
    value: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Portal/Wishlist/QuestionAnswer.js